// extracted by mini-css-extract-plugin
export default {"container":"VM-z","darkBackground":"WM-z","whiteBackground":"XM-z","headerButton":"YM-z","calloutHeading":"ZM-z","calloutSubHeading":"_M-z"};